import { getAuthErrorDataByStatusCode } from '../constants/errors';
import CustomError from '../utils/error';
import serverApi, { serverApiWithAuth } from './index';

export const login = async (username, password) => {
  const payload = JSON.stringify({
    username,
    password
  });
  try {
    return await serverApi.post('/login', payload);
  } catch (e) {
    const error = getAuthErrorDataByStatusCode(e.status);
    throw new CustomError(error.message, error.errorCode, error.data);
  }
};

export const register = async (username, shouldJoinEasyvoteSchool) => {
  const payload = JSON.stringify({
    username,
    joinEasyvoteSchool: shouldJoinEasyvoteSchool
  });
  try {
    return await serverApi.post('/register', payload);
  } catch (e) {
    throw e.data;
  }
};

export const facebookAuthRequest = async facebookAccessToken => {
  const payload = JSON.stringify({
    facebookAccessToken
  });
  try {
    return await serverApi.post('/login-facebook', payload);
  } catch (e) {
    throw e.data;
  }
};

export const getProfile = async () => serverApiWithAuth.get('/profile');
